import { useQuery } from "@tanstack/react-query";
import { useUserStore } from "@/store/userStore";
import { getAccessibleCalendars } from "@/services/edgeFunctionWrappers/calendarsWrapper";

/**
 * Calendriers accessibles par l'utilisateur pour un gym selon son abonnement actif.
 * - Pas d'abonnement actif → []
 * - Abonnement universel (aucun lien subscription_type_calendars) → tous les calendriers
 * - Abonnement avec calendriers restreints → seulement ceux liés
 * Utilisé côté client pour filtrer les cours affichés dans le planning.
 */
export function useAccessibleCalendars(gymId: string | null) {
  const userId = useUserStore((s) => s.user?.id);

  const query = useQuery({
    queryKey: ["accessible-calendars", userId, gymId],
    queryFn: () => getAccessibleCalendars(userId!, gymId!),
    enabled: !!userId && !!gymId,
    staleTime: 60000,
  });

  const calendarIds = (query.data ?? []).map((c) => c.id);
  return {
    accessibleCalendars: query.data ?? [],
    accessibleCalendarIds: calendarIds,
    isLoading: query.isLoading,
    error: query.error,
    hasAccess: calendarIds.length > 0,
  };
}
